import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import "./router/main.css"; // 글로벌 CSS 파일 경로를 수정합니다.

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
